// Utils/authUtils.js
import { toast } from "react-toastify";
import { RoutesPaths } from "../Router/constant";

export const handleTokenVerification = async (navigate, message = "Token or Session Expired") => {
  try {
    localStorage.removeItem("token");
    toast.error(message);
    navigate(RoutesPaths.SIGNIN); // This is safe as long as the caller isn't re-triggered after route change
  } catch (err) {
    console.error("Logout failed:", err);
  }
};


